export default "__VITE_PUBLIC_ASSET__afa937e3__"